import React from 'react';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Form from 'react-bootstrap/Form';

import Gear from '../../Icons/gear.jsx';

import { showColumn } from './columns.jsx';


class Configuration extends React.Component {
  constructor(props) {
    super(props);

    this.onColumnChange = this.onColumnChange.bind(this);
  }

  onColumnChange(event) {
    if (event.target.checked) {
      this.props.showColumn(event.target.value);
    } else {
      this.props.hideColumn(event.target.value);
    }
  }

  render() {
    var columns = this.props.columns;
    var settings = this.props.setting;

    var _columns = [];
    for (var i = 0; i < columns.length; i++) {
      var column = columns[i];

      var selected = showColumn(settings, column);

      _columns.push(
        <Dropdown.ItemText key={column.id}>
          <Form.Check
            custom
            id={'asset-table-configuration' + column.id}
            value={column.id}
            label={column.title}
            checked={selected}
            onChange={this.onColumnChange}
          />
        </Dropdown.ItemText>
      );
    }

    return (
      <div className="text-right mx-4">
        <Dropdown alignRight>
          <Dropdown.Toggle variant="cs-config" size="sm" id="asset-table-configuration">
            <Gear />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Header>Show/Hide Columns</Dropdown.Header>
            {_columns}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
}


export default Configuration;

